import { apiClient, handleResp } from './utils';
export default {
  getPageBy(slug) {
    return handleResp(apiClient().get(`/pages/fetch_by?slug=${slug}`));
  },
  getMonthlyPages() {
    return handleResp(apiClient().get(`/monthly_videos`));
  },
};
